import { configureStore } from '@reduxjs/toolkit';
import authReducer from './slices/authSlice';
import museumReducer from './slices/museumSlice';

export const store = configureStore({
  reducer: {
    auth: authReducer,
    museum: museumReducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
